import { COUNT_DEFAULT, DependencyFilterKeys, PAGE_DEFAULT } from '../../../shared/dependenciesV2';
import { empty } from '../asyncValue';
import type { DependenciesV2Store } from './types';

const initialState: Readonly<DependenciesV2Store> = Object.freeze({
  /**
   * The current project or release group scope
   */
  scope: null,
  /**
   * Indicates if a user is logged in and belong's to the target project's org.
   */
  isOrgMember: false,
  /**
   * Dependencies represents the dependencies currently being displayed in the table
   */
  dependencies: empty(),
  /**
   * Total dependencies represents the total number of dependencies in the project
   */
  totalDependencies: 0,
  /**
   * Filters
   */
  filters: {
    [DependencyFilterKeys.Title]: undefined,
    [DependencyFilterKeys.Status]: [],
    [DependencyFilterKeys.Depth]: [],
    [DependencyFilterKeys.LayerDepth]: [],
    [DependencyFilterKeys.HasIssues]: [],
    [DependencyFilterKeys.Licenses]: [],
    [DependencyFilterKeys.Fetchers]: [],
    [DependencyFilterKeys.ShowIgnored]: undefined,
  },
  /**
   * Pagination
   */
  page: PAGE_DEFAULT,
  count: COUNT_DEFAULT,
  /**
   * Licenses
   */
  licenses: empty(),
  /**
   * Package managers
   */
  packageManagers: empty(),
  /**
   * Root projects
   */
  rootProjects: empty(),
  /**
   * Correct dependency
   */
  correctDependency: empty(),
  /**
   * Resolve dependency
   */
  resolveDependency: empty(),
  /**
   * Build watch state
   * Holds state for watching GET /api/revisions for build data
   */
  buildWatch: {
    // Timeout loop for watching revisions
    interval: undefined,
    // Revisions to watch
    revisionsToWatch: [],
    // Response data
    revisions: empty(),
  },
});

export default initialState;
